<template>
    <div class="auction-state w-6 lg:w-24 h-6 rounded"
         :class="stateClass">
        <icon name="badge-check" class="h-4 w-4 mr-2" v-if="state === 'passed'"/>
        <icon name="star" class="h-4 w-4 mr-2" v-if="state === 'active'"/>
        <span class="invisible lg:visible">{{ state }}</span>
    </div>
</template>

<script>
import Icon from "../Icon";

export default {
    props: {
        state: String,
    },
    components: {
        Icon
    },
    computed: {
        stateClass() {
            switch (this.state) {
                case 'passed':
                    return 'bg-green-200 text-green-800';
                case 'skipped':
                    return 'bg-red-200 text-red-700';
                case 'active':
                    return 'bg-green-200 text-green-800';
                case 'next':
                    return 'bg-orange-200 text-orange-700';
                case false:
                    return 'border-white text-white auction-state invisible';
                case 'future':
                    return 'bg-gray-200 text-gray-400';
            }
        }
    }
}
</script>
